import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import {
  authInterceptor,
  payloadEncryptionInterceptor,
  rateLimitInterceptor,
  unauthorizedInterceptor,
} from './shared/interceptors';
import { API_BASE_URL } from './core/tokens/api-base-url.token';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import Mytheme from './mytheme';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: API_BASE_URL, useValue: environment.domainOrchApiUrl },
    provideHttpClient(
      withInterceptors([
        payloadEncryptionInterceptor,
        authInterceptor,
        unauthorizedInterceptor,
        rateLimitInterceptor,
      ]),
    ),
    provideRouter(
      routes,
      /** So “New Chat” → `/ai-agent` re-runs the route when already on `/ai-agent` (no full browser reload). */
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    providePrimeNG({
      theme:{
        preset:Mytheme,
        options:{
          darkModeSelector:'.app-dark'
        }
      }
    }),
  ]
};
